/**
 * JoinDirect — QR-scan landing route at `/join/:sessionId`.
 *
 * Forwards immediately into the Lobby route, where the WebSocket
 * connection lifecycle and JoinFlow stepper live. Keeps the QR-share
 * URLs short (the QR encodes `/join/<code>` rather than
 * `/game/<code>/lobby`).
 */

import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export function JoinDirect() {
  const params = useParams<{ sessionId: string }>();
  const sessionId = params.sessionId ?? '';
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionId) return;
    navigate(`/game/${sessionId}/lobby`, { replace: true });
  }, [sessionId, navigate]);

  return null;
}
